// extracted by mini-css-extract-plugin
export default {"compare_null_content":"style_compare_null_content__wM7mv","empty_compare_img":"style_empty_compare_img__YbXWV","empty_compare_page":"style_empty_compare_page__zgack"};